
import DivSpan from '@/components/DivSpan';
import searchInput from '@/components/search-input';
import {appBaseUrl} from "../../utils/commons";
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import fileUpload from '@/components/file-upload';
export default {
name: "leave-message-list",
components: {DivSpan,DatetimePlugin,Confirm,searchInput,fileUpload},
directives: {
TransferDom
},
data() {
return {
list: [],
searchData: {},
up: true,
allLoaded: false,
page: 0,
wrapperHeight: 0,
workflowId: '',
codeSort: 'DESC'
}
},

methods: {
changeSup(data){
if(data.cellShow){
this.$set(data,'cellShow',false);
return;
}
this.$set(data,'cellShow',true);
},
addSendMsg(){
this.$router.push(`/workflow/initiate?workflowId=${this.workflowId}&title=发起留言`);
},
init: function() {

this.wrapperHeight =
document.documentElement.clientHeight -
this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$search('/api/leave-message', {sort:'createdDate,'+this.codeSort, page: 0, size: 10},this.searchData).then(list => {
this.list = list;
this.$refs.loadmore.onTopLoaded();
}).catch((error) => {
this.$refs.loadmore.onTopLoaded();
});
},
loadBottom(){
this.page++;
this.$search('/api/leave-message', {sort:'createdDate,'+this.codeSort, page: this.page, size: 10},this.searchData).then(list => {
this.list = this.list.concat(list);
list.length<10?(this.$vux.toast.text('已经加载全部')):''
this.$refs.loadmore.onBottomLoaded();
}).catch((error) => {
this.$refs.loadmore.onBottomLoaded();
});
},
view(requestId) {
this.$router.push('/workflow/'+requestId + '?component=LeaveMessageViewComponent')
},
searchMarker(value) {
this.searchData['commenter.name']=value;
this.getList()
},
delMarker(){
delete this.searchData['commenter.name']
this.getList()
},
searchTitle(value) {
this.searchData['title']=value;
this.getList()
},
delTitle(){
delete this.searchData['title']
this.getList()
},


getList() {
this.$loadingShow();
this.$search('api/leave-message', {sort:'createdDate,'+ this.codeSort,page: 0, size: 10}, this.searchData).then((data) => {
this.list = data;
data.length<10?this.showMore=false:''
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},


goGeneral() {
if(this.$store.state.device === 'wap'){
this.$router.go(-1);
}else{
document.location = "http://action:10002/?";
}
},
changeSort() {
this.codeSort=='ASC'?(this.codeSort='DESC'):(this.codeSort='ASC');
this.getList();
},
getWorkflowId(){
this.$get('api/biz-object-parameters/key/leave').then(data=>{
this.workflowId=data.workflowType;
})
},
},
mounted() {
this.init();
this.getList()
this.getWorkflowId();
},


}



// WEBPACK FOOTER //
// ./src/page/leave-message/leave-message-list.vue